import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./pages/Layout";
import Dashboard from "./pages/Dashboard";
import ThirdPlatform from "./pages/ThirdPlatform";
import Analyse from "./pages/Analyse";
import Alert from "./pages/Alert";
import AlarmSettings from "./pages/AlarmSettings";
import WaterQualitySimulation from "./pages/WaterQualitySimulation";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "thirdplatform",
        element: <ThirdPlatform />,
      },
      {
        path: "analyse",
        element: <Analyse />,
      },
      {
        path: "alert",
        element: <Alert />,
      },
      {
        path: "alarm-settings",
        element: <AlarmSettings />,
      },
      {
        path: "water-flow-simulation",
        element: <WaterQualitySimulation mode="flow" />,
      },
      {
        path: "aeration-simulation",
        element: <WaterQualitySimulation mode="aeration" />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RouterProvider router={router} />
);
